import React from 'react'
import './Terms.css';
import Header from './Header';
import Footer from './Footer';


function About() {
    const navigateToRafiInsta = () => {window.location.href = "https://www.instagram.com/rafi_ul_haq_/";};
    const navigateToRafiLinkedIn = () => {window.location.href = "https://www.linkedin.com/in/rafi-ul-haq";};
  return (
    <div>
        <div class="page">
            <Header />
            <div className='container'>
                <div className='text2 mt-130'>ABOUT US</div>
                <div className='center'>
                    <div className='divbox mobOne'>
                        <div className='d-flex gap-12'>
                            <div><img loading="lazy" className='br-4' width={80} height={80} src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/3fa70851-1a69-4d11-bbe5-2d7215df7100/Digi' /></div>
                            <div className='pr-130'>
                                <div className='divhead'>Aadeel Khan</div>
                                <div className='divdesc mb-18'>CO Founder</div>
                                <div className='d-flex gap-8'>
                                    <div className='divpara cp'>X</div>
                                    <div className='divpara cp'>Insta</div>
                                    <div className='divpara cp'>Linked</div>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex gap-12'>
                            <div><img loading="lazy" className='br-4' width={80} height={80} src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/d1bbc2fc-7eef-4066-a0f7-75078de83700/Digi' /></div>
                            <div className='pr-130'>
                                <div className='divhead'>Rafi</div>
                                <div className='divdesc mb-18'>CTO</div>
                                <div className='d-flex gap-8'>
                                    <div className='divpara cp'>X</div>
                                    <div className='divpara cp' onClick={navigateToRafiInsta}>Insta</div>
                                    <div className='divpara cp' onClick={navigateToRafiLinkedIn}>LinkedIn</div>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex gap-12'>
                            <div><img loading="lazy" className='br-4' width={80} height={80} src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/3be121df-5fad-4a4a-2c1c-05c58afb6700/Digi' /></div>
                            <div className='pr-130'>
                                <div className='divhead'>Anam</div>
                                <div className='divdesc mb-18'>UX Designer</div>
                                <div className='d-flex gap-8'>
                                    <div className='divpara cp'>X</div>
                                    <div className='divpara cp'>Insta</div>
                                    <div className='divpara cp'>LinkedIn</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='center'>
                    <div className='divtext1'>Walletly began in Brisbane, Australia, with an ambitious vision: to bridge ManyChat with Apple Wallet, creating a seamless solution for customer engagement and redefining how businesses connect with their audiences. This early innovation laid the foundation for Walletly to expand into a comprehensive loyalty platform, designed to support shared loyalty among businesses and enhance customer retention with ease.</div>
                </div>
                <br/>
                <div className='center'>
                    <div className='divtext1'>After two years of dedicated development, Walletly became the backend loyalty provider for Cloud Waitress, one of the fastest-growing online ordering platforms</div>
                </div>
                <div className='d-flex gap-46 mt-45 mb-45 p-50-0 mobOne'>
                    <img loading="lazy" width={'260px'} src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/bd3cf520-128a-4b01-178c-85fcc5329500/Digi' />
                    <div className='divtext1 text-center'>Despite challenges during the COVID-19 era,
                        where shifting customer demands and new loyalty trends
                        pushed us to adapt quickly, we overcame obstacles
                        with resilience and creativity.
                        <br/><br/><br/>
                        We navigated the complexities of Apple and Google
                        Wallet integrations, learning firsthand how rapidly technology and
                        market demands can evolve.</div>
                    <img loading="lazy" width={'260px'} src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/7e7f0884-2aad-436b-98d7-54b62be89900/Digi' />
                </div>
                <div className='center'>
                    <div className='divtext1'>Today, Walletly operates from both Seattle, US, and Brisbane, Australia, continuing its journey to empower businesses worldwide. We’re committed to building an impactful loyalty ecosystem, enabling businesses to deliver real-time rewards, run targeted promotions, and foster genuine connections with their customers.</div>
                </div>
                <br/>
                <div className='center'>
                    <div className='divtext1'>Our story is one of passion, persistence, and a vision to drive the future of loyalty technology forward.</div>
                </div>
                <Footer />
            </div>
        </div>
    </div>
  )
}

export default About